import { css } from 'lit';

export const IxEmailListStyles = css`
  :host {
    display: block;
  }
  :host([disabled]) {
    pointer-events: none;
  }
  ix-field {
    display: block;
  }
  ix-field label {
    display: none;
  }
  ix-chip.error {
    --ix-chip-container-color: var(--md-sys-color-error);
    --md-input-chip-outline-color: var(--md-sys-color-error);
  }
  .field-content {
    display: flex;
    flex-wrap: wrap;
    min-height: var(--ix-custom-field-min-height, 24px);
  }
  input {
    border: none;
    background: transparent;
    outline: none;
    min-width: 30%;
    line-height: var(--_content-line-height);
    flex-grow: 1;
  }
  ix-chip-set {
    min-height: var(--_content-line-height);
    display: flex;
    padding-right: 0.5rem;
  }
  ix-icon-button {
    --md-icon-button-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-hover-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-hover-state-layer-color: var(
      --md-sys-text-color-secondary
    );
    --md-icon-button-pressed-icon-color: var(--md-sys-text-color-secondary);
    --md-icon-button-pressed-state-layer-color: var(
      --md-sys-text-color-secondary
    );
  }
  .clear-icon {
    margin-right: 0.5rem;
  }
`;
